import { createFileRoute } from '@tanstack/react-router'

import { ClientsLayout } from '@/components/layout/clients'

export const Route = createFileRoute('/_auth/clients/')({
  component: ClientsPage,
  head: () => ({
    meta: [
      { name: 'SUL AI', content: 'SUL AI' },
      { title: 'SUL AI | Clients' },
    ],
  }),
})

function ClientsPage() {
  return <ClientsLayout />
}
